<template>
	<panel-wrapper :content-class="['box-wap']">
		<template slot="name">
			混音器
		</template>

		<template
			v-if="audioSources"
		>
			<div :class="['overflow-y-auto', 'flex', 'flex-col','box-wap-box']">
				<AudioSource
					v-for="source in audioSources"
					:key="source.name"
					:source="source"
				/>
				<div class="background-content" v-if='showimgTitles'>
					混音器
				</div>	
			</div>
		</template>
		<template v-else>
			音频列表为空? ¯\_(ツ)_/¯
		</template>
	</panel-wrapper>
</template>

<script>
import {mapGetters,mapState} from 'vuex'
import AudioSource from './mixer/source'
import panelMixin from '@/mixins/panel'

export default {

	components: {
		AudioSource
	},

	mixins: [panelMixin],

	computed: {
		...mapState(['showimgTitles']),
		...mapGetters('obs', {
			audioSources: 'sources/audioSources'
		})
	}
}

</script>

<style type="text/css">
</style>
